export const levelType = "level" as const;

export const getLevelResourcePath = (companyId: string, levelId: string) => {
  return `/companies/${companyId}/levels/${levelId}`;
};

export const createLevelResoucePath = (companyId: string) => {
  return `/companies/${companyId}/levels`;
};

export const editLevelResourcePath = (companyId: string, levelId: string) => {
  return `/companies/${companyId}/levels/${levelId}`;
};
